<div class="flex items-center justify-between w-full">
  <div class="instruction-box">
    <p>Click on a nest to move SKUs between nests</p>
  </div>
  <div class="nest-group-actions">
    <ng-container *ngIf="!showLoader; else nestGroupLoader">
      <div class="flex items-center justify-end w-full">
        <div class="flex items-center gap-2">
          <div class="applied-filters" *ngIf="appliedFilters.length > 0">
            <span class="filters-label">Filters Applied :</span>
            <span class="filter-chip" *ngFor="let filter of appliedFilters">
              {{ filter.label }} : {{ filter.value }}
              <img
                src="/assets/images/cross-icon.svg"
                alt="Remove"
                class="remove-filter"
                (click)="removeFilter(filter.key, filter.value)"
              />
            </span>
          </div>
          <app-edit-modify-button
            *ngIf="!lockAssortment"
            (actionButtonCall)="onModifyClick()"
            [disabled]="accessType === 'read'"
          ></app-edit-modify-button>
          <img
            [src]="
              appliedFilters.length > 0
                ? '/assets/images/icon-filter-applied.svg'
                : '/assets/images/icon-filter.svg'
            "
            alt="Filter"
            class="filter-icon"
            (click)="openFilterPanel($event)"
          />
          <app-download-btn
            [showLoader]="downloadLoader"
            (actionBtnCallback)="onDownloadClick($event)"
          ></app-download-btn>
        </div>
      </div>
    </ng-container>
    <ng-template #nestGroupLoader>
      <p-skeleton width="100px" height="36px" styleClass="mb-2"></p-skeleton>
    </ng-template>
  </div>
</div>

<div
  class="cards-container"
  [ngStyle]="{ 'grid-template-columns': 'repeat(' + cols + ', 1fr)' }"
>
  <ng-container *ngIf="!showLoader && paginatedCards.length === 0">
    <div class="no-nests-message">
      <div class="no-nests-header">No nests available</div>
      <div class="no-nests-text">There are no nests to display.</div>
    </div>
  </ng-container>

  <div
    class="card"
    *ngFor="let c of paginatedCards"
    (click)="!lockAssortment && accessType !== 'read' && moveSku(c)"
    [style.cursor]="!lockAssortment ? 'pointer' : 'default'"
  >
    <ng-container *ngIf="!showLoader; else cardLoader">
      <div class="card-header">
        <div class="card-header-info">
          <span class="card-header-text">Nest {{ c.header.nestNumber }}</span>
          <span class="card-header-sub-text">
            PPL Range: {{ c.header.pplRange }} | Beer Types:
            {{ c.header.beerType }}
          </span>
        </div>
      </div>
      <div class="card-stats">
        <div *ngFor="let s of c.stats">
          <span class="stat-label">{{ s.label }}</span
          ><br />
          <span class="stat-value">{{ s.value }}</span>
        </div>
      </div>
      <div class="table-container">
        <table class="card-table">
          <thead>
            <tr>
              <th *ngFor="let col of c.columns">{{ col }}</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let row of c.rows">
              <td>{{ row.sku_detail }}<br />{{ row.sku }}</td>
              <td>{{ row.price_per_ltr }}</td>
              <td>{{ row.ptc_segment }}</td>
              <td>{{ row.brand }}</td>
            </tr>
            <tr *ngIf="c.rows.length === 0">
              <td colspan="4" class="empty-placeholder">
                <div class="empty-placeholder-header">No SKUs to show</div>
                <div class="empty-placeholder-text">
                  Please add some SKUs to the list
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </ng-container>
    <ng-template #cardLoader>
      <p-skeleton height="240px" width="100%" styleClass="mb-4"></p-skeleton>
    </ng-template>
  </div>
</div>

<div class="pagination-footer" *ngIf="!showLoader && paginatedCards.length > 0">
  <div class="footer-left">
    <label>
      Items per page
      <select [(ngModel)]="pageSize" (change)="onPageSizeChange($event)">
        <option *ngFor="let size of pageSizes" [value]="size">
          {{ size }}
        </option>
      </select>
    </label>
    <span>{{ startIndex + 1 }}–{{ endIndex }} of {{ totalItems }} entries</span>
  </div>
  <div class="footer-right">
    <button (click)="prevPage()" [disabled]="currentPage === 1">‹</button>
    <span>
      Page
      <input
        type="number"
        [(ngModel)]="currentPage"
        (change)="onPageInputChange($event)"
        class="page-input"
        [min]="1"
        [max]="totalPages"
      />
      of {{ totalPages }}
    </span>
    <button (click)="nextPage()" [disabled]="currentPage === totalPages">
      ›
    </button>
  </div>
</div>

<p-dialog
  [(visible)]="showMoveSkuPopup"
  [modal]="true"
  [style]="{ width: '60vw', minWidth: '1000px' }"
  [baseZIndex]="10000"
  [dismissableMask]="false"
  [closable]="false"
  contentStyleClass="custom-dialog-content"
  headerClass="custom-dialog-header"
>
  <ng-template pTemplate="header">
    <div class="flex justify-between items-center w-full">
      <p class="header-text">Move SKUs</p>
      <img
        src="/assets/images/cross-icon.svg"
        alt="Close"
        class="cursor-pointer w-4 h-4"
        (click)="onMoveSkuDialogClose()"
      />
    </div>
  </ng-template>

  <ng-template pTemplate="body">
    <div
      *ngIf="tempSelectedCardConfig && !showLoader; else dialogLoader"
      class="dialog-two-cols"
      [class.dragging]="isDragging"
    >
      <!-- LEFT SIDE -->
      <div class="dialog-card dialog-left">
        <div class="dialog-container">
          <div class="card-header">
            <div class="card-header-info">
              <span class="card-header-text"
                >Nest {{ tempSelectedCardConfig.header.nestNumber }}</span
              >
              <span class="card-header-sub-text">
                PPL Range: {{ tempSelectedCardConfig.header.pplRange }} | Beer
                Types: {{ tempSelectedCardConfig.header.beerType }}
              </span>
            </div>
          </div>
          <div class="card-stats">
            <div *ngFor="let s of tempSelectedCardConfig.stats">
              <span class="stat-label">{{ s.label }}</span
              ><br />
              <span class="stat-value">{{ s.value }}</span>
            </div>
          </div>
          <div class="table-container">
            <table class="card-table">
              <thead>
                <tr>
                  <th *ngFor="let col of tempSelectedCardConfig.columns">
                    {{ col }}
                  </th>
                </tr>
              </thead>
              <tbody
                cdkDropList
                id="selectedCardDropList"
                [cdkDropListData]="tempSelectedCardConfig.rows"
                [cdkDropListConnectedTo]="cardDropListIds"
                (cdkDropListDropped)="onDrop($event, 'selected')"
              >
                <tr
                  *ngFor="let row of tempSelectedCardConfig.rows"
                  cdkDrag
                  (cdkDragStarted)="onDragStarted()"
                  (cdkDragEnded)="onDragEnded()"
                >
                  <td>{{ row.sku_detail }}<br />{{ row.sku }}</td>
                  <td>{{ row.price_per_ltr }}</td>
                  <td>{{ row.ptc_segment }}</td>
                  <td>{{ row.brand }}</td>
                  <ng-template cdkDragPreview>
                    <div class="drag-preview-row">
                      <div class="cell">
                        {{ row.sku_detail }}<br />{{ row.sku }}
                      </div>
                      <div class="cell">{{ row.price_per_ltr }}</div>
                      <div class="cell">{{ row.ptc_segment }}</div>
                      <div class="cell">{{ row.brand }}</div>
                    </div>
                  </ng-template>
                </tr>
                <tr *ngIf="tempSelectedCardConfig.rows.length === 0">
                  <td colspan="4" class="empty-placeholder">
                    <div class="empty-placeholder-header">No SKUs to show</div>
                    <div class="empty-placeholder-text">
                      Please add some SKUs to the list
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>

      <!-- RIGHT SIDE -->
      <div class="dialog-card dialog-right-scrollable">
        <div class="nest-group-actions">
          <div class="nest-groups-wrapper">
            <div class="nest-groups" *ngFor="let nestGroup of nestGroupsList">
              <button
                [ngClass]="{
                  selected: popupActiveNestGroup?.value === nestGroup.value,
                }"
                class="nest-group-button"
                (click)="toggleNestGroupInPopup(nestGroup)"
              >
                <span
                  [ngClass]="{
                    'selected-text':
                      popupActiveNestGroup?.value === nestGroup.value,
                  }"
                  class="nest-group-button-text"
                >
                  {{ nestGroup.label }}
                </span>
              </button>
            </div>
          </div>
          <button class="add-button" (click)="addNewNest()">
            Add new nest
          </button>
        </div>

        <p class="helper-text">
          Drag and drop the SKU from left to any nest group of your choice
        </p>

        <ng-container *ngFor="let card of tempCardConfigs; let i = index">
          <div [ngStyle]="{ 'margin-top': i === 0 ? '12px' : '16px' }">
            <p-accordion>
              <p-accordionTab>
                <ng-template pTemplate="header">
                  <div class="card-header">
                    <div class="card-header-info">
                      <span class="card-header-text"
                        >Nest {{ card.header.nestNumber }}</span
                      >
                      <span
                        class="card-header-sub-text"
                        *ngIf="!isPlaceholderStats(card.stats)"
                      >
                        PPL Range: {{ card.header.pplRange }} | Beer Types:
                        {{ card.header.beerType }}
                      </span>
                    </div>
                    <div class="card-header-icons">
                      <img
                        src="/assets/images/chart-toggler.svg"
                        class="toggler-icon"
                      />
                    </div>
                  </div>
                </ng-template>

                <div class="card-stats">
                  <div *ngFor="let s of card.stats">
                    <span class="stat-label">{{ s.label }}</span
                    ><br />
                    <span class="stat-value">{{ s.value }}</span>
                  </div>
                </div>

                <div class="table-container">
                  <table class="card-table">
                    <thead>
                      <tr>
                        <th *ngFor="let col of card.columns">{{ col }}</th>
                      </tr>
                    </thead>
                    <tbody
                      cdkDropList
                      [id]="'cardDropList' + i"
                      [cdkDropListData]="card.rows"
                      [cdkDropListConnectedTo]="['selectedCardDropList']"
                      (cdkDropListDropped)="onDrop($event, i)"
                    >
                      <tr
                        *ngFor="let row of card.rows"
                        cdkDrag
                        (cdkDragStarted)="onDragStarted()"
                        (cdkDragEnded)="onDragEnded()"
                      >
                        <td>{{ row.sku_detail }}<br />{{ row.sku }}</td>
                        <td>{{ row.price_per_ltr }}</td>
                        <td>{{ row.ptc_segment }}</td>
                        <td>{{ row.brand }}</td>
                        <ng-template cdkDragPreview>
                          <div class="drag-preview-row">
                            <div class="cell">
                              {{ row.sku_detail }}<br />{{ row.sku }}
                            </div>
                            <div class="cell">{{ row.price_per_ltr }}</div>
                            <div class="cell">{{ row.ptc_segment }}</div>
                            <div class="cell">{{ row.brand }}</div>
                          </div>
                        </ng-template>
                      </tr>
                      <tr *ngIf="card.rows.length === 0">
                        <td colspan="4" class="empty-placeholder">
                          <div class="empty-placeholder-header">
                            No SKUs to show
                          </div>
                          <div class="empty-placeholder-text">
                            Please add some SKUs to the list
                          </div>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </p-accordionTab>
            </p-accordion>
          </div>
        </ng-container>
      </div>
    </div>

    <ng-template #dialogLoader>
      <p-skeleton width="100%" height="400px"></p-skeleton>
    </ng-template>
  </ng-template>

  <ng-template pTemplate="footer">
    <div class="flex justify-end gap-2 footer-buttons">
      <app-button-secondary
        (actionButtonCall)="onMoveSkuDialogClose()"
        buttonCaption="Cancel"
      ></app-button-secondary>
      <app-button-primary
        buttonCaption="Save"
        (actionButtonCall)="onPopUpSave()"
      ></app-button-primary>
    </div>
  </ng-template>
</p-dialog>

<p-overlayPanel
  #filterPanel
  (onShow)="onFilterPanelShow()"
  (onHide)="onFilterPanelHide()"
>
  <div class="summary-filter-container">
    <div class="summary-filter-header">
      <div class="header-text">Filter By</div>
      <img
        src="/assets/images/cross-icon.svg"
        alt="Cross"
        class="cross-icon"
        (click)="filterPanel.hide()"
      />
    </div>
    <div class="summary-filter-content">
      <ng-container *ngIf="showAccordion">
        <p-accordion
          [multiple]="true"
          class="custom-filter-accordion"
          [activeIndex]="activeAccordionIndex"
        >
          <p-accordionTab *ngFor="let cfg of filterConfigs">
            <ng-template pTemplate="header">
              <div class="filter-title">
                <img
                  src="/assets/images/frame-icon.svg"
                  alt="Frame"
                  class="frame-icon"
                />
                <span>{{ cfg.label }}</span>
              </div>
            </ng-template>
            <div class="filter-body">
              <div class="filter-count">
                {{ filters[cfg.key].selected.length }} Selected
              </div>
              <div class="search-container">
                <div class="search-input-wrapper">
                  <img
                    src="/assets/images/search.svg"
                    alt="Search"
                    class="search-icon"
                  />
                  <input
                    type="text"
                    placeholder="Search"
                    [(ngModel)]="filters[cfg.key].search"
                    class="search-input"
                  />
                </div>
              </div>
              <div class="filter-list">
                <div
                  *ngFor="let item of filteredItems(cfg.key)"
                  class="filter-item"
                  (click)="toggleSelection(cfg.key, item)"
                  [class.selected]="filters[cfg.key].selected.includes(item)"
                >
                  {{ item }}
                </div>
              </div>
            </div>
          </p-accordionTab>
        </p-accordion>
      </ng-container>
    </div>
    <div class="summary-filter-footer">
      <div class="flex justify-end gap-2 footer-buttons filter-buttons">
        <app-button-secondary
          (actionButtonCall)="clearFilter()"
          buttonCaption="Clear"
        ></app-button-secondary>
        <app-button-primary
          buttonCaption="Apply"
          (actionButtonCall)="onFilterApply()"
        ></app-button-primary>
      </div>
    </div>
  </div>
</p-overlayPanel>

<p-dialog
  header="You have unsaved changes. Are you sure you want to leave without saving?"
  [(visible)]="showUnsavedChangesDialog"
  [style]="{ width: '32vw' }"
  [modal]="true"
  [draggable]="false"
>
  <ng-template pTemplate="footer">
    <div class="flex justify-end gap-3">
      <app-button-secondary
        (actionButtonCall)="showUnsavedChangesDialog = false"
        buttonCaption="Cancel"
      ></app-button-secondary>
      <app-button-primary
        buttonCaption="Confirm"
        (actionButtonCall)="closeDialog()"
      ></app-button-primary>
    </div>
  </ng-template>
</p-dialog>
